import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment setting for displaying the V2 attributes display in PDP and Brand pages.
 */
export const BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306 =
  'BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306' as SettingConst<
    'BRAND_REVIEWS_GRANULAR_ATTRIBUTES_DISPLAY_XP_250306',
    boolean,
    'RETAILER' | 'RETAILER_ANDROID' | 'RETAILER_IOS' | 'VISITOR_WEB'
  >;
